module.exports = __webpack_public_path__ + "static/media/dmc-my.1efa0a57.svg";